import { intl } from "@fidget/common/i18n";
import { isEmpty } from "lodash";

export function validateTargetTagGroups(targetIds: string[]) {
    return isEmpty(targetIds)
        ? intl.formatMessage("ai.modelConfiguration.intent.form.response.errorEmpty") : "";
}

export function validateTagGroup(tagGroupId: string) {
    return tagGroupId
        ? "" : intl.formatMessage("ai.modelConfiguration.intent.form.response.errorEmpty");
}
